export default __webpack_public_path__ + "static/media/withdrawal.e8374d1b.svg";